module.exports = {
  appKey: process.env.REACT_APP_KEY,
};
